// @ts-nocheck

export const localeCodes =  [
  "en-GB",
  "en-US"
]
export const localeLoaders = {
  "en-GB": [
    {
      key: "locale_en_45GB_46js_0830fc92",
      load: () => import("#nuxt-i18n/0830fc92" /* webpackChunkName: "locale_en_45GB_46js_0830fc92" */),
      cache: true
    }
  ],
  "en-US": [
    {
      key: "locale_en_45US_46js_8a7490e2",
      load: () => import("#nuxt-i18n/8a7490e2" /* webpackChunkName: "locale_en_45US_46js_8a7490e2" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/c24f973b" /* webpackChunkName: "config_i18n_46config_46ts_c24f973b" */)
]
export const normalizedLocales = [
  {
    code: "en-GB",
    language: "en-GB",
    name: "English (GB)",
    icon: "🇬🇧",
    date: "enGB"
  },
  {
    code: "en-US",
    language: "en-US",
    name: "English (US)",
    icon: "🇺🇸",
    date: "enUS"
  }
]

